// Q7 1〜5スケール
import { Box, Radio, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

import theme from "@/theme";

const useStyles = makeStyles(() => ({
  scaleRoot: {
    marginTop: 16,
  },
  scaleHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 0,
  },
  scaleEndLabel: {
    fontSize: 12,
    [theme.breakpoints.up("md")]: { fontSize: 14 },
    fontWeight: 700,
    whiteSpace: "pre-line",
    lineHeight: 1.3,
    color: theme.palette.text.primary,
    textAlign: "center",
  },
  scaleOptions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    "&:before": {
      content: "\"\"",
      position: "absolute",
      left: 20,
      right: 20,
      height: 1,
      backgroundColor: theme.palette.semantic["border/strong"],
    },
  },
  radio: { width: 44, height: 44, padding: 0 },
  circle: {
    width: 14,
    height: 14,
    borderRadius: 9999,
    border: `1.5px solid ${theme.palette.semantic["border/strong"]}`,
    backgroundColor: theme.palette.common.white,
  },
  selectedCircle: { width: 26, height: 26, borderRadius: 9999, backgroundColor: theme.palette.primary.main },
  scaleNotes: {
    marginTop: 16,
    padding: 12,
    borderRadius: 8,
    backgroundColor: theme.palette.semantic["surface/base"],
  },
  scaleNoteRow: {
    display: "flex",
    gap: 12,
    marginBottom: theme.spacing(0.5),
    fontSize: 12,
    lineHeight: 1.5,
    [theme.breakpoints.up("md")]: { fontSize: 14 },
  },
  scaleNoteLabel: {
    fontWeight: 700,
    flexShrink: 0,
    width: 36,
    color: theme.palette.text.secondary,
  },
  scaleNoteExample: {
    display: "block",
    color: theme.palette.text.secondary,
  },
  scaleFootnote: {
    marginTop: theme.spacing(1),
    fontSize: 12,
    [theme.breakpoints.up("md")]: { fontSize: 14 },
    lineHeight: 1.5,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

type ScaleSelectorProps = {
  min: number;
  max: number;
  leftLabel: string;
  rightLabel: string;
  // example は説明の下に1行で添える具体例（「例）…」）
  notes: { label: string; text: string; example?: string }[];
  footnote?: string;
  value: number | null;
  onChange: (value: number) => void;
};
export const DiagnosisInvestmentStyleScaleSelector: React.FC<ScaleSelectorProps> = ({
  min,
  max,
  leftLabel,
  rightLabel,
  notes,
  footnote,
  value,
  onChange,
}) => {
  const classes = useStyles();
  const steps = Array.from({ length: max - min + 1 }, (_, i) => min + i);
  return (
    <Box className={classes.scaleRoot}>
      <Box className={classes.scaleHeader}>
        <Typography className={classes.scaleEndLabel}>{leftLabel}</Typography>
        <Typography className={classes.scaleEndLabel}>{rightLabel}</Typography>
      </Box>
      <Box className={classes.scaleOptions} role="radiogroup" aria-label="安全性と収益">
        {steps.map((step) => (
          <Radio
            className={classes.radio}
            icon={<span className={classes.circle} />}
            checkedIcon={<span className={classes.selectedCircle} />}
            inputProps={{ "aria-label": `${step} / ${max}` }}
            name="location-yield-preference"
            key={step}
            color="primary"
            checked={value === step}
            onChange={() => onChange(step)}
            value={step}
          />
        ))}
      </Box>
      <Box className={classes.scaleNotes}>
        {notes.map((note) => (
          <Box key={note.label} className={classes.scaleNoteRow}>
            <span className={classes.scaleNoteLabel}>{note.label}</span>
            <span>
              ：{note.text}
              {note.example && <span className={classes.scaleNoteExample}>{note.example}</span>}
            </span>
          </Box>
        ))}
      </Box>
      {footnote && <Typography className={classes.scaleFootnote}>{footnote}</Typography>}
    </Box>
  );
};
